<div class="order-list-container">
  <p-orderList class="activites-order-list"
               [value]="activities" 
               dragdropScope="activities"
               [dragdrop]="true" 
               [responsive]="true"
               (onReorder)="onActivityReorder($event)">
    <ng-template let-activity pTemplate="item">
      <app-activity [activity]="activity"
                    (click)="onSelectActivity($event)">
      </app-activity>
    </ng-template>
  </p-orderList>
</div>